import 'react-app-polyfill/ie9' // For IE 9-11 support
import 'react-app-polyfill/ie11' // For IE 11 support
import './polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import * as serviceWorker from './serviceWorker'
import { I18nextProvider } from 'react-i18next'
// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";
import TagManager from 'react-gtm-module'

import i18n from './i18n'
import App from './App'

if (process.env.NODE_ENV === 'production' && /addons\.weldingo\.com$/.test(window.location.hostname)) {
  
  // Google Tag Manager
  const hostname = window && window.location && window.location.hostname
  if(/weldingo\.com$/.test(hostname) && process.env[`REACT_APP_GTM_${/([a-zA-Z-]+).weldingo.com/.exec(hostname)[1].toUpperCase().replace("-", '_')}`]) {
    const tagManagerArgs = {
      gtmId: process.env[`REACT_APP_GTM_${/([a-zA-Z-]+).weldingo.com/.exec(hostname)[1].toUpperCase().replace("-", '_')}`]
    } 
    TagManager.initialize(tagManagerArgs)
  }

  // Sentry.init({
  //   dsn:  process.env.REACT_APP_SENTRY_DSN,
  //   integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
  //   tracesSampleRate: 1.0,
  // });
}

ReactDOM.render(
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>, 
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
